import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import action from "../../../store/action";
import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js";

/**
 * @description create gum function. In order to batch creation gum
 * @param props The parameter passed by the attribute within the tag
 * */
function GumModel(props) {
  const { model, opacity } = props;

  const depthWrite = opacity === 1 ? true : false;

  return (
    <mesh
      geometry={model}
      opacity={opacity}
      matrixAutoUpdate={false}
      renderOrder={0}
    >
      <meshStandardMaterial
        color={"#ff8888"}
        opacity={opacity}
        transparent={true}
        depthWrite={depthWrite}
        depthTest={true}
        roughness={0.4}
        metalness={0}
        reflectivity={0.1}
        emissive={"#6a1653"}
        emissiveIntensity={0.1}
      />
    </mesh>
  );
}

const mapStateToProps = (state) => ({
  sliderVal: state.webViewer.sliderVal,
  view: state.webViewer.view,
  keyframeNumber: state.webViewer.keyframeNumber,
});

const mapDispatchToProps = (dispatch) => ({
  setView: (val) => dispatch(action.setView(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GumModel);
